module.exports = "../dist/img/clipart-grass-crop-10.9a86.png";